import React, { useEffect } from 'react';
import { useTheme } from '../../App';

export default function CustomSolutions() {
  const { isNightMode } = useTheme();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      padding: '100px 20px 60px',
      minHeight: '80vh',
      background: isNightMode ? '#111827' : '#f9fafb',
      color: isNightMode ? '#f9fafb' : '#111827'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '36px', marginBottom: '20px' }}>Custom Solutions</h1>
        <img 
          src={`${process.env.PUBLIC_URL}/assets/images/p2.png`} 
          alt="Custom Solutions" 
          style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '12px', marginBottom: '30px' }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80';
          }}
        />
        <p style={{ fontSize: '18px', lineHeight: 1.8, marginBottom: '24px', color: isNightMode ? '#d1d5db' : '#4b5563' }}>
          Every project is unique. We offer custom manufacturing and bespoke orders tailored precisely to your specific requirements. Whether you need specialized architectural elements, custom-sized materials, or unique finishes, our manufacturing partners can deliver exactly what you envision.
        </p>
        <p style={{ fontSize: '18px', lineHeight: 1.8, marginBottom: '40px', color: isNightMode ? '#d1d5db' : '#4b5563' }}>
          Get in touch with our experts to discuss your specific needs and let us build the perfect solution for you.
        </p>
        <a href="/contact" style={{ display: 'inline-block', padding: '12px 24px', background: '#16a34a', color: 'white', textDecoration: 'none', borderRadius: '6px', fontWeight: 'bold' }}>
          Contact Us for Custom Orders
        </a>
      </div>
    </div>
  );
}
